import React from 'react'

function AboutSeven() {
    return (
        <div>
            {/* about company area start */}
            <div className="rts-about-ten-area rts-section-gapBottom mt-decrease">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="title-area-left-ten center">
                                <span className="pre-title">About Our Company</span>
                                <h2 className="title">
                                    Our Mission is to Become <br />
                                    <span>The Best Company</span>
                                </h2>
                            </div>
                        </div>
                    </div>
                    <div className="row mt--50">
                        <div className="col-lg-12">
                            <div className="thumbnail-about-loarge-img">
                                <img src={`${process.env.PUBLIC_URL}/assets/images/about/04.png`} alt="about" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* about company area end */}
        </div>
    )
}

export default AboutSeven